import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["thresholdValue", "slider", "label"];

  connect() {
    // Ensure match threshold updates correctly
    this.thresholdValueTarget?.addEventListener("input", this.updateThreshold.bind(this));

    // Attach event listeners to all sliders
    this.sliderTargets.forEach(slider => {
      slider.addEventListener("input", this.updateGroupWeights.bind(this));
    });
  }

  updateThreshold(event) {
    this.updateDisplayValue("threshold_value", event.target.value);
  }

  updateGroupWeights(event) {
    const changedSlider = event.target;
    const group = changedSlider.dataset.group;
    const targetId = changedSlider.dataset.labelTarget; // Updated from `data-target`
    
    this.updateDisplayValue(targetId, changedSlider.value);
    this.adjustGroupWeights(group, changedSlider);
  }

  updateDisplayValue(targetId, value) {
    const displayElement = this.labelTargets.find(el => el.id === targetId);
    if (displayElement) {
      displayElement.textContent = parseFloat(value).toFixed(2);
    }
  }

  adjustGroupWeights(group, changedSlider) {
    const groupSliders = this.sliderTargets.filter(slider => slider.dataset.group === group);
    const changedValue = parseFloat(changedSlider.value);
    const otherSliders = groupSliders.filter(s => s !== changedSlider);

    const remaining = 1.0 - changedValue;
    const totalOther = otherSliders.reduce((sum, s) => sum + parseFloat(s.value), 0);

    otherSliders.forEach(slider => {
      const currentVal = parseFloat(slider.value);
      const newValue = totalOther > 0 ? (currentVal / totalOther) * remaining : remaining / otherSliders.length;

      slider.value = Math.max(0, Math.min(1, newValue.toFixed(4)));
      this.updateDisplayValue(slider.dataset.labelTarget, slider.value);
    });

    const total = groupSliders.reduce((sum, s) => sum + parseFloat(s.value), 0);
    const error = 1.0 - total;

    if (Math.abs(error) > 0.00001) {
      const adjustableSlider = otherSliders.find(s => parseFloat(s.value) + error >= 0 && parseFloat(s.value) + error <= 1)
        || changedSlider;

      adjustableSlider.value = (parseFloat(adjustableSlider.value) + error).toFixed(4);
      this.updateDisplayValue(adjustableSlider.dataset.labelTarget, adjustableSlider.value);
    }
  }
}
